import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RegionMenuSettingEntity } from '../../domain/entities/RegionMenuSettingEntity'
import type { RegionMenuSettingAdminDto } from '@/backend/market'

export class RegionMenuSettingModel extends RegionMenuSettingEntity {
  constructor(dataDto: RegionMenuSettingAdminDto) {
    super()
    mapEntityProperties<RegionMenuSettingEntity>(this, dataDto)
  }
}
